const NumberComponent = (number) => {
  const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
  const englishDigits = "0123456789";
  if (number !== null) {
    return number
      .toString()
      .split("")
      .map((char) =>
        englishDigits.includes(char)
          ? persianDigits[englishDigits.indexOf(char)]
          : char
      )
      .join("");
  }
};

export default NumberComponent;
